import React from "react";
import EVBusinessPerformanceReportBreadCrumbs from "../../Components/EVBusinessPerformanceReport/EVBusinessPerformanceReportBreadCrumbs";
import EVBusinessPerformanceReport from "../../Components/EVBusinessPerformanceReport/EVBusinessPerformanceReport";

export default function EVBusinessPerformanceReportListing() {
  return (
    <React.Fragment>
      <div className="page-content">
        <EVBusinessPerformanceReportBreadCrumbs />
        <EVBusinessPerformanceReport />
      </div>
    </React.Fragment>
  );
}
